import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthogService from "../utils/posthog";

const PostHogProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // initialize posthog on component mount
    posthogService.init();
  }, []);

  useEffect(() => {
    // track page views on route changes
    if (location.pathname) {
      posthogService.capturePageView(location.pathname);
    }
  }, [location.pathname]);

  return children;
};

export default PostHogProvider;
